<script setup lang="ts">
import SectionTaskInfoCreate from './SectionTaskInfoCreate.vue'

defineOptions({
  name: 'TasksKanbanCreationPage',
})
</script>

<template>
  <SectionTaskInfoCreate />
</template>
